export default __webpack_public_path__ + "static/media/edit.1b150ee4.svg";